import { VideoSizes } from '@anm/hosting-player';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatronProject } from 'types/project';

import { landingsActions, landingsSelectors } from '../../../../store/modules/landings';
import { projectSelectors } from '../../../../store/modules/project';

const useFetchLanding = (hostId: string, project: AnimatronProject | null) => {
  const landing = useSelector(landingsSelectors.selectLanding);
  const videoSizes = useSelector(projectSelectors.selectCurrentProjectSizes) as VideoSizes;

  const dispatch = useDispatch();

  useEffect(() => {
    if (landing?.hostId === hostId || !project) return;

    dispatch(
      landingsActions.getLanding({
        hostId,
        params: {
          videoSizes
        }
      })
    );
  }, [project]);

  return landing;
};

export default useFetchLanding;
